export const capitalizarTexto = (texto) => {
    if (!texto || typeof texto !== "string") return "";

    //Listas de preposições que devem ficar em minúsculo
    const excecoes  = ['e','de', 'da', 'do', 'das', 'dos', 'em', 'no', 'na', 'nos', 'nas', 'a', 'o', 'as', 'os'];

    return texto
    .trim()
    .toLowerCase()
    .split(/\s+/) // Divide o texto por espaços
    .map((palavra, index) => {
        // Sempre capitaliza a primeira palavr; as demais checa as exceções
        if (index !== 0 && excecoes.includes(palavra)) {
            return palavra; // Mantém a palavra em minúsculo
        }
        // Capitaliza a primeira letra da palavra
        return palavra.charAt(0).toUpperCase() + palavra.slice(1);
    })
    .join(" "); // Junta as palavras de volta em uma string
};